'use client'

import type { FC } from 'react'
import Turnstile from 'react-turnstile'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

export const turnstileFieldConfig = {
    extraPropsKind: 'turnstile' as const
} satisfies Partial<import('./types').FieldTypeConfig>

const TurnstileField: FC<FieldRendererProps> = ({ field, error, onChange, turnstileRef }) => {
    const siteKey = process.env.TURNSTILE_SITE_KEY || ''

    return (
        <FieldWrapper fieldName={field.name} error={error}>
            <div className='flex flex-col gap-2 w-full'>
                <Turnstile
                    sitekey={siteKey}
                    onSuccess={token => onChange(field.name, token, field)}
                    onLoad={widgetId => {
                        if (turnstileRef && 'current' in turnstileRef) {
                            ;(turnstileRef as React.MutableRefObject<unknown>).current = widgetId
                        }
                    }}
                />
            </div>
        </FieldWrapper>
    )
}

export default TurnstileField
